import { render } from "./AiChatOpenAi.vue?vue&type=template&id=7892c425&ts=true"
import script from "./AiChatOpenAi.vue?vue&type=script&lang=ts"
export * from "./AiChatOpenAi.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__